/* unplugin-vue-components disabled */import { render } from "./simple-header.vue?vue&type=template&id=0ee1a053&scoped=true&ts=true"
import script from "./simple-header.vue?vue&type=script&lang=ts"
export * from "./simple-header.vue?vue&type=script&lang=ts"

import "./simple-header.vue?vue&type=style&index=0&id=0ee1a053&lang=less&scoped=true"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee1a053"]])

export default __exports__